import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const MMAIcon = observer('MMAIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17.5554 7.55556C17.5554 6.94444 18.0554 6.44444 18.6665 6.44444C19.2776 6.44444 19.7776 6.94444 19.7776 7.55556V10.6667C19.7776 10.8111 19.7665 10.9556 19.7332 11.1L18.8443 15.5444C18.7443 16.0333 18.2554 16.4333 17.7554 16.4333H6.24433C5.71099 16.4333 5.25544 16.0667 5.15544 15.5444L4.26655 11.1C4.23322 10.9556 4.22211 10.8111 4.22211 10.6667V4.22222C4.22211 3 5.22211 2 6.44432 2H15.3332C16.5554 2 17.5554 3 17.5554 4.22222V7.55556ZM7.55543 9.77778H14.2221C14.8332 9.77778 15.3332 9.27778 15.3332 8.66667V7.55556C15.3332 6.94444 14.8332 6.44444 14.2221 6.44444H7.55543C6.94432 6.44444 6.44432 6.94444 6.44432 7.55556V8.66667C6.44432 9.27778 6.94432 9.77778 7.55543 9.77778Z'
                fill='fill'
            />
            <path
                d='M7.55544 22C6.94433 22 6.44434 21.5 6.44434 20.8889V17.5556H17.5554V20.8889C17.5554 21.5 17.0554 22 16.4443 22H7.55544Z'
                fill='fill'
            />
        </SvgElement>
    );
});
